
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IDocument, IGLBatchReceipt, IGLBatchReceiptPayer, IGLBatchReceiptSaveCriteria } from "@tylertech/tyler-api-types";

/**
 * GLBatchReceiptService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GLBatchReceiptService {
    constructor(private readonly $apiService: ApiService) { }
    
    DeleteReceipt(pId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/DeleteReceipt", pId);
    }
    GetNewReceipt(): Promise<IGLBatchReceipt> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/GetNewReceipt");
    }
    GetReceipt(pId: string): Promise<IGLBatchReceipt> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/GetReceipt", pId);
    }
    PrintDocuments(pIds: string[]): Promise<IDocument> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/PrintDocuments", pIds);
    }
    ReceiptDefaultsSetup(): Promise<boolean> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/ReceiptDefaultsSetup");
    }
    SavePayer(pPayer: IGLBatchReceiptPayer): Promise<IGLBatchReceiptPayer> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/SavePayer", pPayer);
    }
    SaveReceipt(pCriteria: IGLBatchReceiptSaveCriteria): Promise<IGLBatchReceiptSaveCriteria> {
        return this.$apiService.sendAuth("IGLBatchReceiptService/SaveReceipt", pCriteria);
    }
}
